interface CircularProgressProps {
  progress: number;
}

export const CircularProgress = ({ progress }: CircularProgressProps) => {
  // Calculamos la longitud total del círculo (2 * PI * radio)
  const circumference = 2 * Math.PI * 48; // 48 es el radio que estamos usando (48%)
  
  // Calculamos la longitud del trazo basado en el progreso
  const strokeDashoffset = ((100 - progress) / 100) * circumference;

  return (
    <>
      {/* Background ring */}
      <div className="absolute inset-0 rounded-full border-4 border-white/10 bg-black/50 backdrop-blur-sm" />
      
      {/* Glow effect behind progress */}
      <div 
        className="absolute inset-4 rounded-full bg-primary/20 blur-xl transition-opacity duration-300"
        style={{ opacity: progress / 100 }}
      />
      
      <svg className="absolute inset-0 h-full w-full -rotate-90">
        {/* Background track */}
        <circle
          cx="50%"
          cy="50%"
          r="48%"
          stroke="currentColor"
          strokeWidth="4"
          fill="none"
          className="text-white/5"
        />
        {/* Progress ring */}
        <circle
          cx="50%"
          cy="50%"
          r="48%"
          stroke="currentColor"
          strokeWidth="6"
          fill="none"
          className="text-primary transition-all duration-200"
          strokeDasharray={`${circumference}, ${circumference}`}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          style={{
            transformOrigin: 'center',
            filter: 'drop-shadow(0 0 12px hsl(var(--primary) / 0.6))',
          }}
        />
      </svg>
    </>
  );
};
